module.exports = __webpack_public_path__ + "static/media/hadassah.f4e79c83.png";